import api from "../../../../BasicComponent/Service/api";
import { USER_ACCESS_URL } from "../../../Utils/constService";

/**
 * Fetch all menu permissions saved for a role.
 * Returns an array of { menuKey, canRead, canCreate, canUpdate, canDelete }
 */
export const fetchRoleAccess = (roleUuid) => {
  return api.get(`${USER_ACCESS_URL}/${roleUuid}`);
};

/**
 * Overwrite all menu permissions for a role.
 * @param {string} roleUuid
 * @param {Array}  permissions - flat array of { menuKey, canRead, canCreate, canUpdate, canDelete }
 */
export const saveRoleAccess = (roleUuid, permissions) => {
  return api.put(`${USER_ACCESS_URL}/${roleUuid}`, { permissions });
};